import React from 'react';
import { queries } from '../../graphql/graphql';
import ListContainer, { ListItem } from '../../components/containers/AdminList';
import { Link } from 'react-router-dom';
import { Card } from 'antd';

const CustomCard = ({
  item,
  prefix,
}: {
  item: ListItem;
  refetch: () => void;
  prefix: string;
  roles?: string[];
}) => {
  // const [MAP_RESULT_DELETE] = useMutation(mutations.MAP_RESULT_DELETE);

  // const deleteItem = () => {
  //   MAP_RESULT_DELETE({ variables: { id: item.id } }).then(
  //     res => {
  //       message.success('Card deleted');
  //       refetch();
  //     },
  //     err => {
  //       console.log(err);
  //       message.error('Error.');
  //     }
  //   );
  // };

  // const confirmDelete = () => {
  //   deleteItem();
  // };

  // const cancelDelete = () => {
  //   message.info('Deletion cancelled');
  // };

  const getActions = (item: ListItem) => {
    const actions = [
      <Link key={`link-view-${item.id}`} to={`/plan/${item.plan}/${item.id}`}>
        <span>View</span>
      </Link>,
      <Link key={`link-user-${item.id}`} to={`/admin/user/${item.user}`}>
        <span>User</span>
      </Link>,
      // <Popconfirm
      //   title="Are you sure to delete this result?"
      //   onConfirm={confirmDelete}
      //   onCancel={cancelDelete}
      //   okText="Yes"
      //   cancelText="No"
      //   key={`link-result-delete-${item.id}`}
      // >
      //   <Button type="danger" style={{ marginLeft: '10px' }}>
      //     Delete
      //   </Button>
      // </Popconfirm>
    ];
    return actions;
  };

  return (
    <Card
      hoverable
      cover={
        item.snapshot && (
          <img
            alt=""
            src={item.snapshot as string}
            style={{ maxWidth: '100%', aspectRatio: 1 / 1, objectFit: 'cover' }}
          />
        )
      }
      actions={getActions(item)}>
      <Card.Meta
        title={<Link to={`/${prefix}/${item.id}`}>{item.title || item.name}</Link>}
        description={(item.map && item.map.address) || 'Address is empty'}
      />
    </Card>
  );
};

const ListUsers: React.FC = () => {
  return (
    <ListContainer
      prefix="plans-list"
      query={queries.map.MAP_RESULTS}
      editable={false}
      canCreate={false}
      CustomCard={CustomCard}
    />
  );
};

export default ListUsers;
